export const SIM = 'sim'
export const DEVICE = 'device'

export const APP_NAME = "PME"

export const simGroups = {
    ATTIVE: "attive",
    IN_ATTIVAZIONE: "inAttivazione",
    DA_ATTIVARE: "daAttivare",
    SOSTITUTIVE: "sostitutive",
    SOSPESE: "sospese"
}
